
const API={
    getcode:"/auth/code",//获取验证码
    login:"/auth/login",//登录
    logout:"/auth/logout",//登出
    usermenu:"/api/menus/build",//获取用户菜单权限
    users:"/api/users",//用户
    total:"/api/homePage/total",//查询首页统计数据
    total1:"/api/homePage/total1",//查询首页统计数据
    sevenDays:"/api/homePage/sevenDays",//查询首页七天数据
    summaryTotal:"/api/summaryTotal",//统计页上面统计
    order:"/api/order",//订单列表
    callorder:"/api/order/call",//催收订单列表
    overdueorder:"/api/order/overdue/call",//逾期订单列表
    mycallorder:"/api/order/mycall",//我的催收订单列表
    repayment:"/api/repayment",//还款列表
    rollover:"/api/rollover",//展期、逾期列表
    externalOrder:"/api/externalOrder",//外部订单
    userInfo:"/api/mcashuser/info",// 认证信息
    accountBook: "/api/accountBook", //账期
    classify: "/api/classify", //催收分类
    classifyAll: "/api/classify/all", //催收分类
    group: "/api/group", //催收小组
    orderDetail: "/api/order/detail", //订单详情
    userContact: "/api/order/userContact", //订单用户的联系人
    callInfo: "/api/callInfo", //订单催收信息
    distributor: "/api/order/distributor", //分配订单
    contactInfo: "/api/mcashuser/contactInfo", //紧急联系人信息
    myOrderRecord:"/api/order/myOrderRecord",//我的订单记录
    sysNews:"/app/sysNews",//短信记录
    callTotal:"/api/homePage/callTotal",//查询首页统计数据
    callSuccTotal:"/api/order/callSuccTotal",//催收成功订单
    callDayTotal:"/api/homePage/callDayTotal",//查询今日催收统计数据
    callOldTotal:"/api/homePage/callOldTotal",//查询历史催收统计数据
    queryDayDetail:"/api/homePage/queryDayDetail",//查看每天详情
    groupAll: "/api/group/all", //催收小组
    derate:"/api/derate", //催收减免
    callreport:"/api/call/data/callreport", //催收报表
    daycall:"/api/call/data/daycall", //每日数据总览
    queryCall:"/api/call/data/queryCall", //查询每日数据总览
    loan:"/api/call/data/loan",//贷后整体数据页面
    payError:"/api/order/payError",//放款失败订单
    lendingAgain:"/api/order/lendingAgain",//重新放款
    channelAn:"/api/bazaar/channelAn",//投放渠道分析
    complexPower:"/api/bazaar/complexPower",//复借率统计
    getUserTime:"/api/mcashuser/getUserTime",//获取多少时间没有新增用户
    calldateil:"/api/call/data/calldateil",//在催历史统计详情
    monitorData:"/api/risk/monitor/data",//风控数据监控
    calluser:"/api/call/data/user",//催收员工
    callSuccyqTotal:"/api/order/callSuccyqTotal",//催收成功逾期订单
    sevenEsDays:"/api/homePage/sevenEsDays",//查询预估七天数据
    cancelarOrder:"/api/order/cancelar",//结清订单
    orderMoneyTax:"/api/order/moneyTax",//订单金额减免
    pushinfo:"/api/push/info",//消息推送
    categor:"/api/categor",//等級
    plantilla:"/api/plantilla",//消息模板
    mcashuser:"/api/mcashuser",//mcash用户
    check:"/api/check",//信息审核
    cardcheck:"/api/check/card",//身份证审核
    checkorder:"/api/check/order",//审核订单
    loanPay:"/api/check/orderPay",//订单放款
    myUserAuth:"/api/mcashuser/myUserAuth",//自己的审核用户
    addBlacklist:"/api/mcashuser/addBlacklist",//添加黑名单
    dial:"/api/mcashuser/dial",//语音拨打
    walky:"/api/walky",//话机拨打记录
    agingInfo:"/api/order/aging/info",//分期信息
    saveAgingOrder:"/api/order/saveAgingOrder",//保存分期订单
    agingCheck:"/api/order/agingCheck",//分期订单生效
    proofquery:"/api/order/proofquery",//订单放款凭证查询
    relevanceOrder:"/api/order/relevanceOrder",//关联订单
    profitStatistics:"/api/order/profit/statistics",//利润报表
    associatedTel:"/api/order/associated/tel",//关联电话
    labour:"api/plantilla/labour", //人工推送
    superfluous:"/api/repayment/superfluous",//还款列表

    
    registerPay:"/api/report/registerPay",//注册交易报表
    registerPayNew:"/api/report/registerPayNew",//注册交易报表-新
    loaninfo:"/api/report/loaninfo",//放款报表
    dueDate:"/api/report/dueDate",//到期日报表
    relending:"/api/report/relending",//复贷报表
    profit:"/api/report/profit",//利润报表
    totalAdvert:"/api/report/totalAdvert",//总广告分析报表
    weekAdvert:"/api/report/weekAdvert",//周广告分析报表

    typeList: "/api/report/typeChannel", //渠道
    appChannel: "/api/report/appChannel", //app渠道
    subProductChannel: "/api/report/subProductChannel", //子产品渠道

    collmonitor:"/api/call/data/collmonitor", //催收监控
    setlink:'/api/order/setlink',//设置还款链接
    installment:'/api/order/installment',//手动展期
    download:"/api/order/download",//逾期订单数据导出
    smsconfig:"/api/smsconfig", //催收短信配置

}

export default API